import React, { Component } from "react";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import Intro from "./Intro";
import Record from "./Record";
import Listen from "./Listen";
import Tutorial from "./Tutorial";

import { BrowserRouter as Router, Route } from "react-router-dom";

class App extends Component {
  render() {
    return (
      <Router onUpdate={() => window.scrollTo(0, 0)}>
        <div className="App">
          <br />
          <Header />
          <div className="page">
            <Route exact path="/" component={Intro} />
            <Route path="/record" component={Record} />
            <Route path="/listen" component={Listen} />
            <Route path="/tutorial" component={Tutorial} />
          </div>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js